"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _recompose = require("../recompose");
var _styled = _interopRequireWildcard(require("../styled"));
var _i18n = require("../i18n");
var _DropdownMagnet = _interopRequireDefault(require("./DropdownMagnet"));
var _templateObject, _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Wrapper = _styled.default.ul(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  list-style-type: none;\n  ", ";\n"])), function (props) {
  return props.theme.media.min.md(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n    > div {\n      height: ", ";\n      position: relative;\n      z-index: 2;\n    }\n  "])), (0, _styled.rem)(40));
});
var Label = (0, _i18n.withTranslation)('app.sorting')(function (props) {
  return /*#__PURE__*/_react.default.createElement("span", props);
});
var SortBoxMagnet = function SortBoxMagnet(_ref) {
  var options = _ref.options,
    _select = _ref.select,
    selected = _ref.selected;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": "SortBoxMagnet"
  }, /*#__PURE__*/_react.default.createElement(_DropdownMagnet.default, {
    options: options,
    selected: selected.value,
    select: function select(value) {
      return _select(options.find(function (option) {
        return option.value === value;
      }));
    },
    header: function header(value) {
      return /*#__PURE__*/_react.default.createElement(Label, {
        intlKey: value || 'default'
      });
    }
  }, function (value) {
    return /*#__PURE__*/_react.default.createElement(Label, {
      intlKey: value
    });
  }));
};
var _default = exports.default = (0, _recompose.compose)((0, _recompose.withProps)(function (_ref2) {
  var options = _ref2.options;
  return {
    options: [{
      key: null,
      ascending: true,
      value: 'default',
      enabled: true
    }].concat(options.map(function (option) {
      return Object.assign({}, option, {
        enabled: true
      });
    }))
  };
}))(SortBoxMagnet);